import type { FC } from 'react'
import type { CrmSettingsProviderProps } from './types'
import { WealthboxCrmSettingsProvider } from './WealthboxCrmSettingsProvider'
import { RedtailCrmSettingsProvider } from './RedtailCrmSettingsProvider'
import { PractifiCrmSettingsProvider, SalesforceCrmSettingsProvider, XLR8CrmSettingsProvider } from './SalesforceBasedCrmSettingsProvider'
import {
  BlackDiamondCrmSettingsProvider,
  DynamicsCrmSettingsProvider,
  ElementsCrmSettingsProvider,
  EngageCrmSettingsProvider,
} from './DynamicsBasedCrmSettingsProvider'
import { AdvisorEngineCrmSettingsProvider } from './AdvisorEngineCrmSettingsProvider'
import { HubspotCrmSettingsProvider } from './HubspotCrmSettingsProvider'
import { SmartOfficeCrmSettingsProvider } from './SmartOfficeCrmSettingsProvider'
import { OrionCrmSettingsProvider } from './OrionCrmSettingsProvider'
import { BlackDiamondWPCrmSettingsProvider } from './BlackDiamondWPCrmSettingsProvider'
import { PreciseFPCrmSettingsProvider } from './PreciseFPCrmSettingsProvider'
import { RightCapitalCrmSettingsProvider } from './RightCapitalCrmSettingsProvider'
import { WealthCrmSettingsProvider } from './WealthCrmSettingsProvider'
import { ZohoCrmSettingsProvider } from './ZohoCrmSettingsProvider'
import { EMoneyCrmSettingsProvider } from './EMoneyCrmSettingsProvider'
import { SchwabCrmSettingsProvider } from './SchwabCrmSettingsProvider'
import { IntegrationServiceId } from '../../../../common/integrations'

export const ONBOARDING_CRM_SETTINGS_PROVIDERS: Partial<Record<IntegrationServiceId, FC<CrmSettingsProviderProps>>> = {
  [IntegrationServiceId.WEALTHBOX]: WealthboxCrmSettingsProvider,
  [IntegrationServiceId.REDTAIL]: RedtailCrmSettingsProvider,
  [IntegrationServiceId.SALESFORCE]: SalesforceCrmSettingsProvider,
  [IntegrationServiceId.PRACTIFI]: PractifiCrmSettingsProvider,
  [IntegrationServiceId.XLR8]: XLR8CrmSettingsProvider,
  [IntegrationServiceId.DYNAMICS]: DynamicsCrmSettingsProvider,
  [IntegrationServiceId.ELEMENTS]: ElementsCrmSettingsProvider,
  [IntegrationServiceId.ENGAGE]: EngageCrmSettingsProvider,
  [IntegrationServiceId.BLACK_DIAMOND]: BlackDiamondCrmSettingsProvider,
  [IntegrationServiceId.ADVISOR_ENGINE]: AdvisorEngineCrmSettingsProvider,
  [IntegrationServiceId.HUBSPOT]: HubspotCrmSettingsProvider,
  [IntegrationServiceId.SMARTOFFICE]: SmartOfficeCrmSettingsProvider,
  [IntegrationServiceId.ORION]: OrionCrmSettingsProvider,
  [IntegrationServiceId.BLACK_DIAMOND_WP]: BlackDiamondWPCrmSettingsProvider,
  [IntegrationServiceId.PRECISE_FP]: PreciseFPCrmSettingsProvider,
  [IntegrationServiceId.RIGHT_CAPITAL]: RightCapitalCrmSettingsProvider,
  [IntegrationServiceId.WEALTH]: WealthCrmSettingsProvider,
  [IntegrationServiceId.ZOHO]: ZohoCrmSettingsProvider,
  [IntegrationServiceId.E_MONEY]: EMoneyCrmSettingsProvider,
  [IntegrationServiceId.SCHWAB]: SchwabCrmSettingsProvider,
}
export const getOnboardingCrmSettingsProvider = (serviceId: IntegrationServiceId): FC<CrmSettingsProviderProps> | undefined =>
  ONBOARDING_CRM_SETTINGS_PROVIDERS[serviceId]
